import * as yup from 'yup';

export const eeGeneralInformationSchema = yup.object().shape({
	ScorecardRefNumber: yup.string().nullable(),
	ScorecardName: yup.string().nullable().required('Scorecard Name is required'),
	YearReportIsSubmitted: yup
		.date()
        .required('Year report is submitted is required')
		.typeError('Year report is submitted is required'),
	ApplicableEAPYear: yup
		.number()
		.nullable()
		.transform((curr, orig) => (orig === 0 || orig === '' ? null : curr))
		.required('Applicable Eap Year is required'),	  
	AppliedEapPercentage: yup
		.number()
		.nullable()
		.transform((curr, orig) => (orig === 0 || orig === '' ? null : curr))
		.required('Applied EAP % is required'),
	ApplicableSectoralTargetYear: yup
		.object()
		.shape({
			Id: yup.string(),
			Name: yup.string(),
		})
		.nullable()
		.required('Applicable Sectoral Target is required'),	
	AppliedSectoralPercentage: yup
		.object()
		.shape({
			Id: yup.number(),
			Name: yup.string(),
		})
		.nullable()
		.transform((curr: any, orig: number) => (orig === 0 ? null : curr))
		.required('Applied Sectoral % is required'),	
	SetaClassification: yup
		.number()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr)),
	ReportPeriodDateFrom: yup.date().nullable().required('From date is required').typeError('From date is required'),
	ReportPeriodDateTo: yup.date().nullable().required('To date is required').typeError('To date is required'),
	EEPlanDateFrom: yup.date().nullable().required('From date is required').typeError('From date is required'),
	EEPlanDateTo: yup.date().nullable().required('To date is required').typeError('To date is required'),
	EEPlanYears: yup.number().nullable().required('EE Plan years is required'),
	WorkforceProfileSnapshotDate: yup.date().nullable().required('Workforce Profile snapshot date is required'),
	TradeName: yup.string().nullable(),
	DTIRegistrationName: yup
		.string()
		.nullable()
		.required('DTI Registration Name is required'),
	DTIRegistrationNumber: yup.string().nullable(),
	PayeSarsNumber: yup.string().nullable(),
	UIFReferenceNumber: yup.string().nullable(),
	EEReferenceNumber: yup.string().nullable(),
	Industry: yup
		.object()
		.shape({
			Id: yup.string(),
			Name: yup.string(),
		})
		.nullable(),
	TelephoneNumber: yup
		.string()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.min(10, 'Phone Number too short')
		.max(10, 'Phone Number too long')
		.matches(
			/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid phone number'
		),

	CeoName: yup.string().nullable(),
	CeoSurname: yup.string().nullable(),
	CeoTelephoneNumber: yup
		.string()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.min(10, 'Phone Number too short')
		.max(10, 'Phone Number too long')
		.matches(
			/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid phone number'
		),
	CeoEmail: yup
		.string()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.matches(
			/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/,
			'Invalid email address'
		),

	SeniorManagerName: yup.string().nullable(),

	SeniorManagerSurname: yup.string().nullable(),

	SeniorManagerTelephoneNumber: yup
		.string()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.min(10, 'Phone Number too short')
		.max(10, 'Phone Number too long')
		.matches(
			/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid phone number'
		),

	SeniorManagerEmail: yup
		.string()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr))
		.matches(
			/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/,
			'Invalid email address'
		),

	BusinessType: yup
		.object()
		.shape({
			Id: yup.string(),
			Name: yup.string(),
		})
		.nullable()
		.required('Business Type is required'),

	NumberOfEmployees: yup
		.object()
		.shape({
			Id: yup.string(),
			Name: yup.string(),
		})
		.nullable()
		.required('Number Of Employees is required'),

	BargainingCouncil: yup
		.object()
		.shape({
			Id: yup.string(),
			Name: yup.string(),
		})
		.nullable()
		.required('Bargaining Council is required'),
	
	IsOrganOfState: yup
		.boolean()
		.transform((value, originalValue) => {
			return originalValue === '' ? null : value;
		})
		.nullable()
		.required('Organisation an organ of state selection is required'),

	IsGroup: yup
		.boolean()
		.transform((value, originalValue) => {
			return originalValue === '' ? null : value;
		})
		.nullable()
		.required('Organisation part of a group selection is required'),
	
	GroupName: yup.string()
		.nullable()
		.when('IsGroup', {
			is: true,
			then: schema => schema.required('Group name is required when organisation is part of a group'),
			otherwise: schema => schema.notRequired(),
	  	}),

	PhysicalAddress: yup.object().shape({
        AddressLine1 : yup.string().nullable().max(100, 'Address Line too long! (Max 100 characters)'),
        AddressLine2 : yup.string().nullable().max(100, 'Address Line too long! (Max 100 characters)'),
        Suburb : yup.object().shape({
			Id: yup.string(),
			Name: yup.string(),
		}).nullable(),
        City : yup.object().shape({
			Id: yup.string(),
			Name: yup.string(),
		}).nullable(),
        Province : yup.object().shape({
			Id: yup.string(),
			Name: yup.string(),
		}).nullable(),
        Code: yup
			.string()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr))
			.min(4, 'Invalid Postal Code')
			.max(4, 'Invalid Postal Code')
			.matches(/^\d+$/, 'Postal Code should have digits only'),
    })
    .nullable(),
    PostalAddress: yup.object().shape({
        AddressLine1 : yup.string().nullable().max(100, 'Address Line too long! (Max 100 characters)'),
        AddressLine2 : yup.string().nullable().max(100, 'Address Line too long! (Max 100 characters)'),
        Suburb : yup.object().shape({
			Id: yup.string(),
			Name: yup.string(),
		}).nullable(),
        City : yup.object().shape({
			Id: yup.string(),
			Name: yup.string(),
		}).nullable(),
        Province : yup.object().shape({
			Id: yup.string(),
			Name: yup.string(),
		}).nullable(),
        Code: yup
			.string()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr))
			.min(4, 'Invalid Postal Code')
			.max(4, 'Invalid Postal Code')
			.matches(/^\d+$/, 'Postal Code should have digits only'),
    })
    .nullable(),
	
	FinalisedEEAnalysisDate: yup
		.date()
		.transform((value, originalValue) => {
			return originalValue === '' ? null : value;
		})
		.nullable()
})
.test(
  'to-date-after-from-date',
  '',
  function (values) {
    const { ReportPeriodDateFrom, ReportPeriodDateTo } = values as {
      ReportPeriodDateFrom: Date | null;
      ReportPeriodDateTo: Date | null;
    };

    if (!ReportPeriodDateFrom || !ReportPeriodDateTo) return true;

    if (new Date(ReportPeriodDateTo).getTime() <= new Date(ReportPeriodDateFrom).getTime()) {
      return this.createError({
        path: 'ReportPeriodDateTo',
        message: 'To date must be after From date',
      });
    }

    return true;
  }
);
